import { render, staticRenderFns } from "./AdditionalCostsForm.vue?vue&type=template&id=0fa57422&lang=pug"
import script from "./AdditionalCostsForm.vue?vue&type=script&lang=js"
export * from "./AdditionalCostsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports